import React, { useState } from "react";

import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Form from 'react-bootstrap/Form'

import {Redirect} from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { Card, Col } from 'react-bootstrap'
import {myStorage,myFirestore} from '../../services/firebase'
import {connect} from 'react-redux'
import moment from 'moment'
function WritepostBtn(props) {
    
    const [imageAsFile, setImageAsFile] = useState('')
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    let imageAsUrl=''
    
    const handleFireBaseUpload = e => {
        e.preventDefault()
      console.log('start of upload')
      // async magic goes here...
      if(imageAsFile === '') {
        console.error(`not an image, the image file is a ${typeof(imageAsFile)}`)
      }
      const uploadTask = myStorage.ref(`/blogsImages/${imageAsFile.name}`).put(imageAsFile)
      //initiates the firebase side uploading 
      uploadTask.on('state_changed', 
      (snapShot) => {
        //takes a snap shot of the process as it is happening
        console.log(snapShot)
      }, (err) => {
        //catches the errors
        console.log(err)
      }, () => {
        // gets the functions from storage refences the image storage in firebase by the children
        // gets the download url then sets the image from firebase as the value for the imgUrl key:
        myStorage.ref('blogsImages').child(imageAsFile.name).getDownloadURL()
         .then(fireBaseUrl => {
        //    setImageAsUrl(prevObject => ({...prevObject, imgUrl: fireBaseUrl}))
                imageAsUrl=fireBaseUrl;
                handleSubmit(e);
           console.log(imageAsUrl)
         })
      })
      }
      const handleImageAsFile = (e) => {
        const image = e.target.files[0]
        setImageAsFile(imageFile => (image))
        
    }
    const handleSubmit=(event)=>{

        myFirestore.collection('blogs').doc(title).set({
            title,
            desc:text.toString(),
            imageUrl:imageAsUrl,
            authorId:props.auth.uid,
            authorName:props.profile.username,
            isCounselor:props.profile.isCounselor,
            date:moment().unix()
        }).then(fireBase => {
            props.showToast(1,"Blog Published");
            props.history.push('/blogs');
        }
        );
    }
    const handleTitle=(e)=>{
        setTitle(e.target.value);
        console.log('title:'+title)
    }
    const handleText=(e)=>{

        setText(e.target.value);
        console.log('text:'+text)
    }
    if(!props.auth.uid) return <Redirect to='/signin'/>;
    return (
        
        <div className="container-fluid d-flex justify-content-center" style={{ height: "100%", padding: "2rem", background: "linear-gradient(#40817a, #7cbdc9)" }}>



            <Card style={{
                width: "50rem", padding: "2rem", boxShadow: "0 0.9rem 0.9rem 0 rgba(0,0,0,0.2)",
                borderRadius: "0.8rem",
                marginBottom:'5rem'

            }}>
                <Form onSubmit={handleFireBaseUpload}>


                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <p style={{ paddingRight: "1rem", fontFamily: "bold", fontSize: "20px" }}> Title: </p>
                    </InputGroup.Prepend>

                    <FormControl
                        onChange={handleTitle}
                        placeholder="Title"
                        aria-label="Title"
                        aria-describedby="title"
                    />
                </InputGroup>

                <InputGroup style={{ height: "10rem" }}>
                    <InputGroup.Prepend>
                        <p style={{ paddingRight: "1rem", fontFamily: "bold", fontSize: "20px" }}> Your Text: </p>
                    </InputGroup.Prepend>
                    <FormControl onChange={handleText} as="textarea" aria-label="With textarea" />
                </InputGroup>

                
                    <Form.Group>
                        <Form.File onChange={handleImageAsFile} accept="image/*" id="FormControlFile" label="Upload photo:" style={{ paddingRight: "1rem", fontFamily: "bold", fontSize: "20px" }} />
                        <img src={imageAsUrl} alt='' />
                    </Form.Group>
                    <Col >
                <Button variant="light" type='submit'  style={{ width: "100%" }}>
                    Save        </Button>
            </Col>
               
                

                </Form>

            </Card>
        </div>



    );
}

// function Example() {
//     const [show, setShow] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     return (
//         <>
            

//             <Modal show={show} onHide={handleClose}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Are you sure?</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>Do you want to save the changes?</Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={handleClose}>
//                         Discard
//             </Button>
//                     <Button variant="primary" onClick={handleClose}>
//                         Save Changes
//             </Button>
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// }

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile

    }
}

 
export default connect(mapStateToProps)(WritepostBtn);
// export { Example }
